import { useBlogFooterData } from "@/hooks/useBlogFooterData";
import { useBlogNavData } from "@/hooks/useBlogNavData";
// import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { FC, ReactNode, memo, useEffect } from "react";

import {
  Box,
  Footer,
  GlobalStyle,
  Link,
  NavDesktopUnderlay,
  Navigation,
  waitTillTrue,
} from "@ms/gatsby-theme";

import { PreFooterEmailForm } from "@/components/PreFooterEmailForm";

interface PageLayoutProps {
  path: string;
  children: ReactNode;
}

const PageLayout: FC<PageLayoutProps> = ({ path, children }) => {
  // const [isNavVisible, setIsNavVisible] = useState(true);

  const navData = useBlogNavData();
  const footerData = useBlogFooterData();

  useEffect(() => {
    if (process.env.DY_SECTION_ID) {
      waitTillTrue(
        () => typeof window === "object",
        () => {
          const dyPayload = {
            type: "OTHER",
            lng: "en",
          };
          window.DY = window.DY || {}; // set DY as early as possible
          window.DY.recommendationContext = dyPayload;
        },
      );
    }
  }, []);

  return (
    <>
      <Link
        variant="neutralSmButton"
        sx={{
          left: "5px",
          position: "fixed",
          top: "5px",
          transform: "translateY(-200%)",
          transition: "transform 0.3s ease-in-out",

          // on focus show
          "&:focus": {
            transform: "translateY(0)",
            zIndex: 104,
          },
        }}
        href="#main"
      >
        Skip to Main Content
      </Link>
      <GlobalStyle />

      <Box
        sx={{
          minHeight: "screenHeight",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box as="header" sx={{ position: "fixed", width: "full", zIndex: 50 }}>
          <Navigation navData={navData} />
        </Box>
        {/* Box takes up same space as fixed nav */}
        <Box
          sx={{
            // These values come from useNavHeight - We have to put in a hardcoded version since the calculation is causing jittering
            // due to useEffect. Array is NavHeight + Super Banner Height
            height: [98, 96, null, 157],
            width: "full",
          }}
        />
        <Box
          as="main"
          // use for skip to main content link
          id="main"
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            width: "full",
            zIndex: 0,
          }}
        >
          <NavDesktopUnderlay />
          {children}
        </Box>
        {path !== "/press" && <PreFooterEmailForm />}
        <Footer footerData={footerData} />
      </Box>
    </>
  );
};

export default memo(PageLayout);
